import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';

import { WsService } from 'src/app/modules/core/services/websocket.service';
import { SimulationService } from 'src/app/modules/simulation/services';
import { SIMULATION_EVENT } from '../../types';
@Component({
    selector: 'video-recording-app',
    templateUrl: 'video-recording-dialog.component.html',
    styleUrls: ['./video-recording-dialog.component.scss'],
})
export class VideoRecordingDialogComponent implements OnInit {
    simulationId: any;
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public router: Router,
        public dialog: MatDialog,
        private wsService: WsService,
        public simulationService: SimulationService,
    ) {
        this.simulationId = this.data?.simulationId;
    }
    ngOnInit() {
        this.wsService.connect(this.simulationId);
    }

    btnStartedRecording() {
        this.simulationService.update(this.data).subscribe(result => {
            if (result) {
                this.router.navigateByUrl(`/simulation-started?simulationId=${this.simulationId}`);
                const event = {
                    event: SIMULATION_EVENT.SIMULATION_START
                }
                this.wsService.messages.next(
                    JSON.stringify({
                        data: JSON.stringify(event),
                    }),
                );
                // this.wsService.messages.error({
                //     code: 4000,
                //     reason: 'Some thing went wrong. Please contact customer service to support!',
                // });
            }
        });
        this.dialog.closeAll();
        // this.router.navigateByUrl(`/simulation-started?simulationId=${this.simulationId}`);
    }
}
